import useLocalStorageState from './useLocalStorageState';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useSelectedLocation = () => useLocalStorageState<Record<string, any>[]>('location', []);
export default useSelectedLocation;
